import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Link = ({ url, text, openInNewTab, className }) => {
  return (
    <a
      href={url}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'noreferrer' : undefined}
      className={cn('link', className)}
    >
      {text}
    </a>
  );
};

Link.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  text: PropTypes.string,
  openInNewTab: PropTypes.bool
};

// Let the generator infer types from `propTypes`

export default Link;
